<template>
    <el-carousel v-if="swiperList.length" :interval="2000" indicator-position="outside" class="swiper">
        <el-carousel-item  v-for="(v,i) in swiperList" :key="i">
          <img class="img-item" :src="v" @click="handleJump(i)">
        </el-carousel-item>
    </el-carousel>
</template>
<script>
export default {
  data () {
    return {
      swiperList: [],
      linkurls: []
    }
  },
  methods: {
    handleJump (index) {
      if (!this.linkurls[index]) {
        return
      }
      window.location.href = this.linkurls[index]
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper{
  height:325px;
}
.swiper ::v-deep .el-carousel__indicators--horizontal{
  position:absolute!important;
  bottom:0;
  left:0;
  right:0;
}
.swiper ::v-deep .el-carousel__container{
  height:325px;
}
.swiper ::v-deep .el-carousel__button{
  width:10px;
  height:10px;
  border-radius:50%;
}
.swiper .img-item{
    width:100%;
    height:100%;
}
</style>
